var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player",staticStyle:{"width":"100%"}},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin audio-slideshow",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }